import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "../components/Logo";

export default function ComingSoon({ onOpenAuth }) {
  return (
    <div data-testid="coming-soon-page" className="relative min-h-screen bg-[#090909] overflow-hidden flex flex-col">
      <div className="pointer-events-none absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#C9A227]/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-[#C9A227]/40 to-transparent" />

      <header className="max-w-6xl w-full mx-auto px-6 pt-8">
        <Logo />
      </header>

      <main className="flex-1 max-w-6xl w-full mx-auto px-6 flex flex-col justify-center py-16">
        <div className="eyebrow mb-5 animate-[fadeIn_0.6s_ease-out]">COMING SOON • ONE PIECE • POKÉMON</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] max-w-3xl">
          Il nuovo shop <span className="text-[#C9A227]">PULL STATION</span> sta per aprire.
        </h1>
        <p data-testid="coming-soon-message" className="text-[#9CA3AF] mt-6 max-w-xl text-sm md:text-base">
          Stiamo preparando il nuovo punto di riferimento italiano per preorder JP/EN, sealed e carte singole.
          Ci siamo quasi: presto online.
        </p>
        <div className="mt-10 inline-flex items-center gap-3 text-xs font-mono-ps uppercase tracking-widest text-[#C9A227]">
          <span className="h-2 w-2 rounded-full bg-[#C9A227] animate-pulse" />
          Apertura in arrivo
        </div>
      </main>

      <footer className="max-w-6xl w-full mx-auto px-6 pb-8 flex flex-col md:flex-row justify-between items-center gap-3 text-[11px] font-mono-ps uppercase tracking-widest text-[#6B7280]">
        <span>© 2026 PULL STATION</span>
        <div className="flex items-center gap-5">
          <Link to="/termini" data-testid="coming-soon-terms" className="hover:text-[#C9A227] transition-colors">Termini</Link>
          <Link to="/privacy" data-testid="coming-soon-privacy" className="hover:text-[#C9A227] transition-colors">Privacy</Link>
          <Link to="/cookie" data-testid="coming-soon-cookie" className="hover:text-[#C9A227] transition-colors">Cookie</Link>
          <button onClick={onOpenAuth} data-testid="coming-soon-admin-login" className="inline-flex items-center gap-1 hover:text-[#C9A227] transition-colors">
            <Lock size={11} /> Area riservata
          </button>
        </div>
      </footer>
    </div>
  );
}
